import React from 'react'

function ConnectingDashIcon() {
  return (
    <svg width="17" height="2" viewBox="0 0 17 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="16" height="1" fill="#393939"/>
    </svg>
  )
}

export default ConnectingDashIcon
